import Target_0 from './src/Checkout.jsx';shopify.extend('purchase.thank-you.block.render', (...args) => Target_0(...args));